export enum RoomPrice {
  BY_NIGHT = 'NIGHT',
  TOTAL = 'TOTAL',
}
